import { FileRegistry } from 'utils/file-registry/FileRegistry'
import { logError } from 'utils/logger'

const downloadVideo = (blobUrl: string, fileName: string) => {
  // Create a temporary anchor element to trigger download
  const link = document.createElement('a')
  link.href = blobUrl
  link.download = fileName
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()

  cleanUp(blobUrl, link)
}

const cleanUp = (blobUrl: string, link: HTMLAnchorElement) => {
  const fileRegistry = FileRegistry.getInstance()
  setTimeout(() => {
    document.body.removeChild(link)
    fileRegistry.deleteFile(blobUrl)
  }, 100)
}

export const automaticallyDownloadVideo = async (
  projectName: string,
  downloadUrl: string,
  env: 'local' | 'prod'
) => {
  const fileName = `${projectName}_${env}.mp4`

  try {
    // Fetch the video as a blob
    const response = await fetch(downloadUrl)
    const blob = await response.blob()

    // Create object URL from blob
    const fileRegistry = FileRegistry.getInstance()
    const blobUrl = fileRegistry.registerFile(blob)

    downloadVideo(blobUrl, fileName)
  } catch (error) {
    logError(error)
    downloadVideo(downloadUrl, fileName)
  }
}
